import moment from 'moment'

const EQUIPMENT_REQUEST_STATUS_CHOICES = {
    S: 'Submitted',
    A: 'Approved',
    H: 'Shipped'
}

export function createRequest(request) {

    let item = {
        truck: {...request.truck}
    }

    // job
    item['job'] = request.job.name

    // requestedBy
    item['requestedBy'] = `${request.requestedBy.firstName} ${request.requestedBy.lastName}`

    // dateRequested
    item['dateRequested'] = moment(request.datetimeCreated).format("M/D/YYYY")

    // status
    item['status'] = EQUIPMENT_REQUEST_STATUS_CHOICES[request.status]

    // dateFulfilled
    item['dateFulfilled'] = request.datetimeFulfilled ? moment(request.datetimeFulfilled).format("M/D/YYYY") : null

    return item
}